<template>

    <!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer"> Preferenze </a> 
					<span class="hidden-xs ms-1">\</span>
                    <span class="text-muted ms-1">Configurazione Siti </span>
                </h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
            </div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
						
					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(this.modulo)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(this.modulo)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
		            </div>
		        </div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'webconf-a'}" v-on:click="activeTab = 'webconf-a', getOpzioni(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list me-1"></i>Info
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'webconf-b'}" v-on:click="activeTab = 'webconf-b', getOpzioni(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="false" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-cogs me-1"></i>Setup
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'webconf-c'}" v-on:click="activeTab = 'webconf-c', getOpzioni(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="false" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-sphere me-1"></i>Template
							</div>
						</a>
					</li>
				</ul>
 
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
    <!-- /page header -->
    
    <!-- Content area -->
    <div class="content content-1 table-cms-wrapper">

		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade" id="webconf-a" :class="{'active show': activeTab == 'webconf-a'}">
        		<div class="card shadow mb-xs-3 mb-lg-0">
		            <div class="collapse show" id="collapse-all" style="">				
		                <div class="card-body pb-0">
                            <div class="alert alert-2 alert-secondary border-0"> 
			                    <div class="row">
			                        <div class="col-12 col-md-10 col-lg-10 mbx-1">
		                                <p style="padding: 0 2px; position:relative; top:5px;">
		                                    I campi contrassegnati in <span class="text-danger">rosso</span> sono <strong>Obbligatori</strong>. 
		                                    Inserire dati corretti e veritieri, la maggior parte sono pubblicati su documenti fiscali.
		                                </p>	  
		                            </div>                              
			                        <div class="col-12 col-md-2 col-lg-2 mbx-1 d-grid gap-2">
			                            <button type="submit" class="btn btn-primary btn-block float-end" v-on:click="salvaOpzioni()"><i class="icon-floppy-disk me-2"></i>Salva Modifiche</button>
			                        </div>
			                    </div>
							</div>	
						</div>
			        </div>

                    <div class="card-body box-card mt-0 mb-0" >
                        <div class="box-config" id="tableFixHead">
                            <div class="row">
                                <div class="col-lg-8">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Dati principali</legend>  
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[0].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                    
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Localizzazione</legend>
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[1].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Sessione</legend>
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[2].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
		                        <div class="col-12 col-lg-4" style="border-left: 1px solid rgba(0,0,0,.125);">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0" style="min-height: 14.4rem;">
                                        <legend class="font-weight-semibold mb-2">Contenuti Seo</legend>
                                        <ul class="nav nav-tabs nav-tabs-highlight">
                                            <li class="nav-item" v-for="seo in arrayOpzioniConfigurazione[3].opzioni" v-bind:key="seo.LABEL" >
                                                <a :href="'#tab-'+seo.ID_OPZIONE_BASE" class="nav-link" :class="seo.CLASSE_CTRL" data-bs-toggle="tab" :id="'link_'+seo.ID_OPZIONE_BASE">{{ seo.ETICHETTA }}</a>
                                            </li>
                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane fade mt-2" :class="{'active show' : seo.CLASSE_CTRL == 'input-sm active' , '' : seo.CLASSE_CTRL == 'input-sm' }" v-for="seo in arrayOpzioniConfigurazione[3].opzioni" v-bind:key="seo.LABEL" :id="'tab-'+seo.ID_OPZIONE_BASE">
                                                <IControl :campo="seo" v-model="seo.VALORE" :inputgroup="seo.GROUP" :icon="seo.ICON"></IControl>
                                            </div>  
                                        </div>
                                    </fieldset>
                                </div>
                            </div>                    
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" :class="{'active show': activeTab == 'webconf-b'}">
                <div class="card shadow mb-0 mb-xs-1">
		            <div class="collapse show" id="collapse-all" style="">				
		                <div class="card-body pb-0">
                            <div class="alert alert-2 alert-secondary border-0"> 
			                    <div class="row">
			                        <div class="col-12 col-md-10 col-lg-10 mbx-1">
		                                <p style="padding: 0 2px; position:relative; top:5px;">
		                                    I campi contrassegnati in <span class="text-danger">rosso</span> sono <strong>Obbligatori</strong>. 
		                                    Inserire dati corretti e veritieri, la maggior parte sono pubblicati su documenti fiscali.
		                                </p>	  
		                            </div>                              
			                        <div class="col-12 col-md-2 col-lg-2 mbx-1 d-grid gap-2">
			                            <button type="submit" class="btn btn-primary btn-block float-end" v-on:click="salvaOpzioni()"><i class="icon-floppy-disk me-2"></i>Salva Modifiche</button>
			                        </div>
			                    </div>
							</div>	
						</div>
			        </div>

                    <div class="card-body box-card mt-0 mb-0" >
                        <div class="box-config" id="tableFixHead">
                            <div class="row">
                                <div class="col-lg-3">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Configurazioni FTP</legend>  
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[4].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
		                        <div class="col-12 col-lg-3" style="border-left: 1px solid rgba(0,0,0,.125);">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Configurazioni SMTP</legend>  
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[5].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
		                        <div class="col-12 col-lg-3" style="border-left: 1px solid rgba(0,0,0,.125);">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Configurazioni IMAP</legend>
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[6].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="col-lg-3" style="border-left: 1px solid rgba(0,0,0,.125);"> 
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Manutenzione</legend>
                                        <div class="row">
                                            <div v-for="opz3 in arrayOpzioniConfigurazione[7].opzioni" v-bind:key="opz3.LABEL" class="mb-2" v-bind:class="opz3.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz3.ETICHETTA"></label>
                                                <IControl :campo="opz3" v-model="opz3.VALORE" :inputgroup="opz3.GROUP" :icon="opz3.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>                    
                        </div>
                    </div>


                </div>
            </div>

            <div class="tab-pane fade" :class="{'active show': activeTab == 'webconf-c'}">
                <div class="card shadow mb-0 mb-xs-1">
		            <div class="collapse show" id="collapse-all" style="">				
		                <div class="card-body pb-0">
                            <div class="alert alert-2 alert-secondary border-0"> 
			                    <div class="row">
			                        <div class="col-12 col-md-10 col-lg-10 mbx-1">
		                                <p style="padding: 0 2px; position:relative; top:5px;">
		                                    I campi contrassegnati in <span class="text-danger">rosso</span> sono <strong>Obbligatori</strong>. 
		                                    Inserire dati corretti e veritieri, la maggior parte sono pubblicati su documenti fiscali.
		                                </p>	  
		                            </div>                              
			                        <div class="col-12 col-md-2 col-lg-2 mbx-1 d-grid gap-2">
			                            <button type="submit" class="btn btn-primary btn-block float-end" v-on:click="salvaOpzioni()"><i class="icon-floppy-disk me-2"></i>Salva Modifiche</button>
			                        </div>
			                    </div>
							</div>	
						</div>
			        </div>

                    <div class="card-body box-card mt-0 mb-0" >
                        <div class="box-config" id="tableFixHead">
                            <div class="row">
                                <div class="col-lg-8">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Configurazioni Template</legend>  
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[8].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="col-lg-4" style="border-left: 1px solid rgba(0,0,0,.125);">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Loghi</legend>  
                                        <div class="row">
                                            <div v-for="opz1 in arrayOpzioniConfigurazione[9].opzioni" v-bind:key="opz1.LABEL" class="mb-2" v-bind:class="opz1.COL">
                                                <label class="form-label text-danger mb-1" v-html="opz1.ETICHETTA"></label>
                                                <IControl :campo="opz1" v-model="opz1.VALORE" :inputgroup="opz1.GROUP" :icon="opz1.ICON"></IControl>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                            </div>
                        </div>
                    </div>
                                
                </div>
            </div>


        </div>
    </div>



    <div class="modal fade" id="popUpUploadLogoHeader" role="dialog"  tabindex="-1" >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header modal-header-2 bg-secondary text-white">
                    <h6 class="modal-title">
                        <i class="fal fa-location fa-fw fa-lg" style="color:#FFF;"></i> <span style="top: -1px; position: relative;"> Upload </span>
                    </h6>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
                </div>
                <div class="modal-body">  
                    <Upload @onsuccess="successCaricamento($event)" @onerror="errorCaricamento($event)" :args="argsLogoAzienda"  :qs="'&ID_ENTE='+idEnteCorrente"></Upload>
                </div>
            </div>
        </div>
    </div>  

    <div class="modal fade" id="popUpUploadLogoFooter" role="dialog"  tabindex="-1" >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header modal-header-2 bg-secondary text-white">
                    <h6 class="modal-title">
                        <i class="fal fa-location fa-fw fa-lg" style="color:#FFF;"></i> <span style="top: -1px; position: relative;"> Upload </span>
                    </h6>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
                </div>
                <div class="modal-body">  
                    <Upload @onsuccess="successCaricamento($event)" @onerror="errorCaricamento($event)" :args="argsLogoFooter" :qs="'&ID_ENTE='+idEnteCorrente"></Upload>
                </div>
            </div>
        </div>
    </div>  

</template>



<script>

import IControl from '@/components/utils/IControl.vue'
import Upload from '@/components/utils/Upload.vue'

export default {
    name:"ConfWebsite",	

    components:{
        IControl,
        Upload
    },

    data: function () {
        return {   
			apiStartup:'core/admin/opzioni',
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            arrayFunzionalita: new Array(),
            searchFunzionalita:{

            },

            opzioneSelezionata:{},
			activeTab: 'webconf-a',
            idEnteCorrente:0,
            arrayOpzioniConfigurazione:new Array(),
            arrayOpzioniConfigurazioneDefault : new Array(
                {
                    titolo:"Principale",
                    icona:'',
                    visible:false,
                    id:1,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:201, ETICHETTA:'Data apertura Sito',           LABEL:'SITE_STARTDATE',                 TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-2',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-calendar'             },
                        {ID_OPZIONE_BASE:202, ETICHETTA:'Titolo Sito',                  LABEL:'SITE_NAME',                      TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-5',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-info-circle'          },
                        {ID_OPZIONE_BASE:203, ETICHETTA:'Slogan Sito',                  LABEL:'SITE_SLOGAN',                    TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-5',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-align-center'         },                        
                        {ID_OPZIONE_BASE:204, ETICHETTA:'URL Sito',                     LABEL:'SITE_URL',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-4',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-link'                 },
                        {ID_OPZIONE_BASE:205, ETICHETTA:'Tema Sito',                    LABEL:'SITE_THEME',                     TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-2',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-eye'                  },
                        {ID_OPZIONE_BASE:206, ETICHETTA:'Tema Admin',                   LABEL:'ADMIN_THEME',                    TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-2',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-eye'                  },                                                
                        {ID_OPZIONE_BASE:207, ETICHETTA:'Email Admin',                  LABEL:'ADMIN_MAIL',                     TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-4',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-envelope'             },                       
                        {ID_OPZIONE_BASE:208, ETICHETTA:'URL Rewrite',                  LABEL:'ADMIN_URL_REWRITE',              TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:209, ETICHETTA:'Sito Multilingua',             LABEL:'ADMIN_MULTILANGUAGE',            TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:210, ETICHETTA:'Sito Multivaluta',             LABEL:'ADMIN_MULTICURRENCY',            TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:211, ETICHETTA:'Mostra Captcha',               LABEL:'ADMIN_CAPTCHA',                  TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },                        
                        {ID_OPZIONE_BASE:212, ETICHETTA:'Mostra Editor',                LABEL:'ADMIN_ADVANCE_EDITOR',           TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:213, ETICHETTA:'Mostra Banner',                LABEL:'MOSTRA_BANNER',                  TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:214, ETICHETTA:'Api Microsoft Client ID',      LABEL:'API_MICROSOFT_CLIENT_ID',        TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-3 ', CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'fab fa-windows'  },
                        {ID_OPZIONE_BASE:215, ETICHETTA:'Api Microsoft Client Secret',  LABEL:'API_MICROSOFT_CLIENT_SECRET',    TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-3',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'fab fa-windows'  },                        
                        {ID_OPZIONE_BASE:216, ETICHETTA:'Api Google Key ID',            LABEL:'API_GOOGLE_KEY_ID',              TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-3',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'fab fa-google'   },                     
                        {ID_OPZIONE_BASE:217, ETICHETTA:'Api Google Client Secret',     LABEL:'API_GOOGLE_CLIENT_SECRET',       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-3',  CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'fab fa-google'   },                                               
                    )
                },
                {
                    titolo:"Lingua",
                    icona:'',
                    visible:true,
                    id:2,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:221, ETICHETTA:'Lingua di Default',            LABEL:'LANG_DEFAULT',                   TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-2',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:222, ETICHETTA:'Formato ora Locale',           LABEL:'LANG_FORMAT_DATA',               TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-2',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:223, ETICHETTA:'Timezone del Sito',            LABEL:'LANG_TIMEZONE',                  TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-3',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:224, ETICHETTA:'Fuso orario',                  LABEL:'LANG_JET_LAG',                   TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-3',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:225, ETICHETTA:'Formato unix',                 LABEL:'LANG_LOCAL_TIME',                TYPE:"TEXT",    VALORE:'-',     COL:'col-6 col-md-2',   CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-user-cog' },              
                    )
                },
                {
                    titolo:"Sessione",
                    icona:'',
                    visible:true,
                    id:3,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:231, ETICHETTA:'TimeOut Sessione',             LABEL:'TIMEOUT_SESSIONE',               TYPE:"TEXT",    VALORE:3600,    COL:'col-6 col-md-2',   },
                        {ID_OPZIONE_BASE:232, ETICHETTA:'Reload Sessione scaduta',      LABEL:'RELOAD_SESSIONE_SCADUTA',        TYPE:"SELECT",  VALORE:1,       COL:'col-6 col-md-3',   OPTIONS:new Array({ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:233, ETICHETTA:'Soglia multipla',              LABEL:'SOGLIA_MULTIPLE_INSERT',         TYPE:"SELECT",  VALORE:0,       COL:'col-6 col-md-2',   OPTIONS:new Array({ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})  },
                        {ID_OPZIONE_BASE:234, ETICHETTA:'Sessione per utente',          LABEL:'FLG_UNA_SESSIONE_PER_UTENTE',    TYPE:"TEXT",    VALORE:'',      COL:'col-6 col-md-2',   },
                 
                    )
                },
                {
                    titolo:"SEO",
                    icona:'',
                    visible:true,
                    id:4,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:241, ETICHETTA:'Titolo',                       LABEL:'SEO_TITLE',                      TYPE:"TEXT",        VALORE:'-',     COL:'col-12',   CLASSE_CTRL:'input-sm active',          GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:242, ETICHETTA:'Descrizione',                  LABEL:'SEO_DESCRIPTION',                TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',   CLASSE_CTRL:'input-sm',     ROWS:'5',   GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:243, ETICHETTA:'Parole Chiavi',                LABEL:'SEO_TAGS',                       TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',   CLASSE_CTRL:'input-sm',                 GROUP:1,    ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:244, ETICHETTA:'Microdati',                    LABEL:'SEO_MICRODATA',                  TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',   CLASSE_CTRL:'input-sm',     ROWS:'14',  GROUP:1,    ICON: 'far fa-user-cog' },                   
                    )
                },
                {
                    titolo:"FTP",
                    icona:'',
                    visible:true,
                    id:5,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:251, ETICHETTA:'Ftp Host',                     LABEL:'FTP_HOST',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:252, ETICHETTA:'Ftp User',                     LABEL:'FTP_USER',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:253, ETICHETTA:'Ftp Password',                 LABEL:'FTP_PASSWORD',                   TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:254, ETICHETTA:'Ftp Path',                     LABEL:'FTP_PATH',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                    )
                },
                {
                    titolo:"EMAIL",
                    icona:'',
                    visible:true,
                    id:6,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:261, ETICHETTA:'Server SMTP',                  LABEL:'SERVER_SMTP',                    TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:262, ETICHETTA:'Porta',                        LABEL:'PORTA',                          TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:263, ETICHETTA:'Sicurezza',                    LABEL:'SICUREZZA',                      TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:264, ETICHETTA:'Esername',                     LABEL:'USERNAME',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:265, ETICHETTA:'Password',                     LABEL:'PASSWORD',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-key' },                       
                        {ID_OPZIONE_BASE:266, ETICHETTA:'Inviato da',                   LABEL:'FROM',                           TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                        {ID_OPZIONE_BASE:267, ETICHETTA:'Rispondi a',                   LABEL:'REPLY_TO',                       TYPE:"TEXT",    VALORE:'-',     COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1,    ICON: 'far fa-user-cog' },                       
                    )
                },
                {
                    titolo:"IMAP",
                    icona:'',
                    visible:true,
                    id:7,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:271, ETICHETTA:'',  LABEL:'SERVER_IMAP',      TYPE:"TEXT", VALORE:'-', COL:'col-12 col-md-12', CLASSE_CTRL:'input-sm', GROUP:1, ICON: 'far fa-server'   },
                        {ID_OPZIONE_BASE:272, ETICHETTA:'',  LABEL:'PORTA_IMAP',       TYPE:"TEXT", VALORE:'-', COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1, ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:273, ETICHETTA:'',  LABEL:'TIPO_SICUREZZA',   TYPE:"TEXT", VALORE:'-', COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1, ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:274, ETICHETTA:'',  LABEL:'DKIM_DOMAIN',      TYPE:"TEXT", VALORE:'-', COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1, ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:275, ETICHETTA:'',  LABEL:'DKIM_KEY',         TYPE:"TEXT", VALORE:'-', COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1, ICON: 'far fa-user-cog' },
                        {ID_OPZIONE_BASE:276, ETICHETTA:'',  LABEL:'DKIM_SELECTOR',    TYPE:"TEXT", VALORE:'-', COL:'col-12 col-md-6',  CLASSE_CTRL:'input-sm', GROUP:1, ICON: 'far fa-user-cog' },
      )
                },
                {
                    titolo:"Manutenzione",
                    icona:'',
					visible:false,
                    id:8,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:281, ETICHETTA:'Sito Offline',                     LABEL:'OFFLINE',                TYPE:"SELECT",      VALORE:0,       COL:'col-12 col-md-6',      ICON:  'icon-construction',     OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'}) },
                        {ID_OPZIONE_BASE:282, ETICHETTA:'Data riapertura',                  LABEL:'OFFLINE_OPENDATA',       TYPE:"TEXT",        VALORE:'-',     COL:'col-12 col-md-6',      CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-calendar' },
                        {ID_OPZIONE_BASE:283, ETICHETTA:'Titolo Offline',                   LABEL:'OFFLINE_TITLE',          TYPE:"TEXT",        VALORE:'-',     COL:'col-12 col-md-12',     CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-h1' },
                        {ID_OPZIONE_BASE:284, ETICHETTA:'Sottotitolo Offline',              LABEL:'OFFLINE_SUBTITLE',       TYPE:"TEXT",        VALORE:'-',     COL:'col-12 col-md-12',     CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-subtitles' },
                        {ID_OPZIONE_BASE:285, ETICHETTA:'Messaggio sito offline',           LABEL:'OFFLINE_MESSAGE',        TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',               CLASSE_CTRL:'input-sm',     ROWS:'5',   GROUP:1,    ICON: 'far fa-pen' },
                    )
                },
                {
                    titolo:"Design",
                    icona:'',
                    visible:false,
                    id:9,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:291, ETICHETTA:'Header Top',                       LABEL:'HEADER_TOP',             TYPE:"SELECT",      VALORE:0,       COL:'col-6 col-md-3',     OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})   },
                        {ID_OPZIONE_BASE:292, ETICHETTA:'Header Bar',                       LABEL:'HEADER_BAR',             TYPE:"SELECT",      VALORE:0,       COL:'col-6 col-md-3',     OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})   },
                        {ID_OPZIONE_BASE:293, ETICHETTA:'Header Principale',                LABEL:'HEADER_MAIN',            TYPE:"SELECT",      VALORE:0,       COL:'col-6 col-md-3',     OPZIONI:new Array({ID:'',DESCRIZIONE:'Seleziona'},{ID:0,DESCRIZIONE:'NO'},{ID:1,DESCRIZIONE:'SI'})   },
                        {ID_OPZIONE_BASE:294, ETICHETTA:'Carosello',                        LABEL:'SEARCH_MAIN',            TYPE:"SELECT",      VALORE:0,       COL:'col-6 col-md-3',     OPZIONI:new Array() },
                    )
                },
                {
                    titolo:"Loghi",
                    icona:'',
                    visible:false,
                    id:10,
                    opzioni: new Array(                                                                                                                                                       
                        {ID_OPZIONE_BASE:301, ETICHETTA:'Header ente',                  LABEL:'HEADER_LOGO_ENTE',               TYPE:"TEXT",    VALORE:'-',     COL:'col-12',           CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-ballot-check'         },
                        {ID_OPZIONE_BASE:302, ETICHETTA:'Footer ente',                  LABEL:'FOOTER_LOGO_ENTE',               TYPE:"TEXT",    VALORE:'-',     COL:'col-12',           CLASSE_CTRL:'input-sm',     GROUP:1,    ICON: 'far fa-calendar'             },

                    )
                },
                
            ),
            argsLogoAzienda:{
                modalita:'THEB_uploadLogoConfig',
                tipo:1,//azienda
            },
            
            argsLogoFooter:{
                modalita:'THEB_uploadLogoConfig',
                tipo:2,//footer
            },
            arrayOpzioniCustom : new Array(),

        }
    },

    methods: {
        getOpzioni : function(activeTab){
            utils.ajax(this.apiStartup,{activeTab:activeTab}, (response) => {
                var arrayOpzioni = response.data;
                this.arrayOpzioniConfigurazione = utils.clone(this.arrayOpzioniConfigurazioneDefault);
                for (var i = 0 ; i < this.arrayOpzioniConfigurazione.length ; i++){
                    for (var j = 0 ; j < this.arrayOpzioniConfigurazione[i].opzioni.length ; j++){
                        //this.arrayOpzioniConfigurazione[i].opzioni[j].CLASSE_CTRL = '';
                        this.arrayOpzioniConfigurazione[i].opzioni[j].VMODEL = 'VALORE';
                        this.arrayOpzioniConfigurazione[i].opzioni[j].ID_OPZIONE = 0;
                        for (var k = arrayOpzioni.length-1 ; k > -1  ; --k){
                            if (this.arrayOpzioniConfigurazione[i].opzioni[j].ID_OPZIONE_BASE == arrayOpzioni[k].ID_OPZIONE_BASE){
                                this.arrayOpzioniConfigurazione[i].opzioni[j].VALORE = arrayOpzioni[k].VALORE;
                                this.arrayOpzioniConfigurazione[i].opzioni[j].ID_OPZIONE = arrayOpzioni[k].ID_OPZIONE;
                                arrayOpzioni.splice(k,1);
                                break;
                            }
                        }
                    }
                }
				 
				/*
                this.arrayOpzioniCustom = utils.array.select(arrayOpzioni,"ID_OPZIONE_BASE",0);
                setTimeout(() => {
                    document.getElementById("tab-251").classList.add("show");
                    document.getElementById("tab-251").classList.add("active");                    
                    document.getElementById("link_251").classList.add("active");
                    document.getElementById("tab-261").classList.add("show");
                    document.getElementById("tab-261").classList.add("active");                    
                    document.getElementById("link_261").classList.add("active");
                }, 300);  
                
                //AGGIUNGO LE OPZIONI CUSTOM DEL SITO
                for (var i = 0 ; i < this.arrayOpzioniConfigurazione.length ; i++){
                    if (this.arrayOpzioniConfigurazione[i].id == 100){
                        for (var j = 0 ; j < arrayOpzioni.length ; j++){
                            this.arrayOpzioniConfigurazione[i].opzioni.push({LABEL:arrayOpzioni[j].LABEL,VALORE:arrayOpzioni[j].VALORE,TYPE:'TEXTAREA',ID_OPZIONE:arrayOpzioni[j].ID_OPZIONE});
                        }
                        this.$forceUpdate();
                        break;
                    }
                }
                */

            });
        },     

        salvaOpzioni : function(){
            var arr = new Array();
            for (var i = 0 ; i < this.arrayOpzioniConfigurazione.length ; i++){
                for (var j = 0 ; j < this.arrayOpzioniConfigurazione[i].opzioni.length ; j++){
                    arr.push(this.arrayOpzioniConfigurazione[i].opzioni[j]);
                }
            }
            for (var i = 0 ; i < this.arrayOpzioniCustom.length ; i++){
                arr.push(this.arrayOpzioniCustom[i]);
            }
            utils.ajax('core/admin/opzioni/update',{opzioni:arr,ID_ENTE:this.idEnteCorrente}, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getOpzioni();
                }
            });
        },

        getConfigurazioniEnte : function(){
            this.getOpzioni(this.activeTab);
        },

        refreshEnte : function(){
            this.idEnteCorrente = this.$root.idEnteCorrente;
            this.getOpzioni(this.idEnteCorrente);
        },

        nuovaOpzioneCustom(){
            this.arrayOpzioniCustom.push({ID_OPZIONE_BASE:0, ETICHETTA:'-',LABEL:'-',TYPE:"TEXTAREA",VALORE:'-', COL:'col-12 col-md-6',CLASSE_CTRL:'input-sm',GROUP:1,ICON: 'far fa-ballot-check'},);
        },

        successCaricamento : function(response){
            utils.alert.success(response.messaggio);
            this.getOpzioni();
        },

        errorCaricamento : function(response){
            utils.alert.warning(response.messaggio);
        },

        imgEnte(idOpzione){
            console.log("***");
            if (this.arrayOpzioniConfigurazione.length > 4){
                var img = utils.array.select(this.arrayOpzioniConfigurazione[4]['opzioni'],"ID_OPZIONE_BASE",idOpzione,1)[0];
                if (img != undefined){
                    return img['VALORE'];
                }
            }
            return "";
        },


    },

    computed: {
        uploadDisabled() {
            return this.files.length === 0;
        }
    },

    beforeCreate : function(){
        setTimeout(() => {
            global.utils.deltaGriglia = 100;   
            global.utils.resizeContent();     
        }, 300);
    },
    
    unmounted : function(){
       global.utils.deltaGriglia = 0;
    },

    created: function () {
        this.idEnteCorrente = this.$root.idEnteCorrente;
       this.getOpzioni(this.idEnteCorrente);
    },

}
</script>